const LoadingPage = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'linear-gradient(180deg, #000D3A 48.5%, #CDD2E0 100%)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      zIndex: 9999,
      fontFamily: 'Arial, sans-serif',
    }}
  >
    <img
      src={process.env.PUBLIC_URL + '/images/img_intro.svg'}
      alt="intro"
      style={{
        width: 120,
        marginTop: '30%',
        marginBottom: 60,
        objectFit: 'contain',
      }}
    />
    <div
      style={{
        width: 48,
        height: 48,
        border: '6px solid rgba(255,255,255,0.3)',
        borderTop: '6px solid #fff',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: 24,
      }}
    />
    <div style={{ color: '#fff', fontSize: 22, fontWeight: 400, textAlign: 'center' }}>loading...</div>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      `}
    </style>
  </div>
);

export default LoadingPage;
